export default "__VITE_PUBLIC_ASSET__356825c5__"